import { z } from 'zod';
import { IdSchema, DateTimeSchema, PaginationParamsSchema } from '../../common';
// ============================================
// Subject
// ============================================
export const SubjectSchema = z.object({
    id: IdSchema,
    name: z.string().min(1).max(120),
    code: z.string().min(1).max(16).nullable(),
    description: z.string().max(2000).nullable(),
    createdAt: DateTimeSchema,
    updatedAt: DateTimeSchema,
});
export const CreateSubjectSchema = z.object({
    name: z.string().min(1).max(120),
    code: z.string().min(1).max(16).optional(),
    description: z.string().max(2000).optional(),
});
export const UpdateSubjectSchema = CreateSubjectSchema.partial();
export const CreateSubjectForGradeSchema = CreateSubjectSchema.extend({
    gradeLevel: z.coerce.number().int().min(1).max(12),
});
export const SubjectGradeLevelParamsSchema = z.object({
    id: IdSchema,
    gradeLevel: z.coerce.number().int().min(1).max(12),
});
// ============================================
// Unit
// ============================================
export const GradeLevelSchema = z.coerce.number().int().min(1).max(12);
export const UnitSchema = z.object({
    id: IdSchema,
    subjectId: IdSchema,
    gradeLevel: GradeLevelSchema,
    name: z.string().min(1).max(160),
    orderIndex: z.number().int().nonnegative().default(0),
    description: z.string().max(2000).nullable(),
    createdAt: DateTimeSchema,
    updatedAt: DateTimeSchema,
});
export const CreateUnitSchema = z.object({
    subjectId: IdSchema,
    gradeLevel: GradeLevelSchema,
    name: z.string().min(1).max(160),
    orderIndex: z.number().int().nonnegative().optional(),
    description: z.string().max(2000).optional(),
});
export const UpdateUnitSchema = CreateUnitSchema.partial();
// ============================================
// Topic
// ============================================
export const TopicSchema = z.object({
    id: IdSchema,
    unitId: IdSchema,
    name: z.string().min(1).max(160),
    orderIndex: z.number().int().nonnegative().default(0),
    description: z.string().max(2000).nullable(),
    createdAt: DateTimeSchema,
    updatedAt: DateTimeSchema,
});
export const CreateTopicSchema = z.object({
    unitId: IdSchema,
    name: z.string().min(1).max(160),
    orderIndex: z.number().int().nonnegative().optional(),
    description: z.string().max(2000).optional(),
});
export const UpdateTopicSchema = CreateTopicSchema.partial();
// ============================================
// Outcome (kazanım)
// ============================================
export const OutcomeSchema = z.object({
    id: IdSchema,
    topicId: IdSchema,
    code: z.string().max(40).nullable(),
    description: z.string().min(1).max(2000),
    orderIndex: z.number().int().nonnegative().default(0),
    createdAt: DateTimeSchema,
    updatedAt: DateTimeSchema,
});
export const CreateOutcomeSchema = z.object({
    topicId: IdSchema,
    code: z.string().max(40).optional(),
    description: z.string().min(1).max(2000),
    orderIndex: z.number().int().nonnegative().optional(),
});
export const UpdateOutcomeSchema = CreateOutcomeSchema.partial();
// ============================================
// Query schemas
// ============================================
export const CurriculumQuerySchema = PaginationParamsSchema.extend({
    search: z.string().optional(),
    gradeLevel: GradeLevelSchema.optional(),
    subjectId: IdSchema.optional(),
});
// ============================================
// Bulk import — Excel (ünite/konu/kazanım) tek seferde
// ============================================
// Her satır bir KAZANIM. Hiyerarşi upsert edilir (ders→ünite→konu→kazanım).
export const ImportCurriculumRowSchema = z.object({
    subject: z.string().min(1).max(120),
    gradeLevel: GradeLevelSchema,
    unit: z.string().min(1).max(160),
    topic: z.string().min(1).max(160),
    outcomeCode: z.string().max(40).optional(),
    outcome: z.string().min(1).max(2000),
});
export const ImportCurriculumSchema = z.object({
    rows: z.array(ImportCurriculumRowSchema).min(1).max(20000),
});
export const ImportCurriculumResultSchema = z.object({
    subjects: z.number().int().nonnegative(),
    units: z.number().int().nonnegative(),
    topics: z.number().int().nonnegative(),
    outcomes: z.number().int().nonnegative(),
    skipped: z.number().int().nonnegative(),
    errors: z.array(z.string()),
});
//# sourceMappingURL=curriculum.js.map